import React, { useEffect, useState } from "react";
import noImage from "../../assets/images/settings/no-image.png";
import decline from "../../assets/images/declined.png";
import sign from "../../assets/images/sign.png";
import axios from "axios";
import "./JuryGroupCard.css";
import { serverInfo } from "../../App";
import { useContext } from "react";
import LoaderPost from "./LoaderPost";

function JuryGroupCard({
  videoType,
  setIsHasNonMarkedVideo,
  assignJury,
  auditionRoundInfo,
  event,
  isPrimary,
  setStep,
  setSingleAssignJury,
  setSingleJuryVideos,
}) {
  const { imageCdnUrl } = useContext(serverInfo);
  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const [videoNumber, setVideoNumber] = useState("");
  const [markedVideoNumber, setMarkedVideoNumber] = useState("");
  const [nonMarkedVideoNumber, setNonMarkedVideoNumber] = useState("");

  const getRoundVideosReportBasedOnSingleJury = () => {
    axios
      .get(
        `/api/audition-admin/audition/videoReportBasedOnSingleJury/${event?.id}/${auditionRoundInfo?.id}/${assignJury?.jury_id}/${videoType}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setVideos(res.data.videos);
          setVideoNumber(res.data.video_number);
          setMarkedVideoNumber(res.data.marked_video_number);
          setNonMarkedVideoNumber(res.data.non_marked_video_number);
          if (res.data.non_marked_video_number > 0) {
            setIsHasNonMarkedVideo(true);
          }
          setLoading(false);

          console.log(res.data);
        }
      });
  };
  const handleDetails = () => {
    setStep(2);
    setSingleAssignJury(assignJury);
    setSingleJuryVideos(videos);
  };

  useEffect(() => {
    getRoundVideosReportBasedOnSingleJury();
  }, [auditionRoundInfo]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className="col-md-4 my-3 d-flex justify-content-center">
            <div className="bg-dark cardBox">
              <div className="px-3 d-flex justify-content-start bg-warning rounded-3">
                <img
                  height={50}
                  width={50}
                  className="img-fluid photoImgStyle py-2"
                  src={
                    assignJury?.user?.image != null
                      ? imageCdnUrl + assignJury?.user?.image
                      : noImage
                  }
                  alt=""
                />
                <div className="d-flex align-items-center">
                  <h6 className="mx-3 text-black juryName">
                    {assignJury?.user?.first_name} {assignJury?.user?.last_name}
                  </h6>
                </div>
              </div>
              <div className="threeF m-3  p-2 rounded-3">
                <div className="d-flex ">
                  <button className="">
                    <i className="fa-solid fa-video text-warning iconJuryTextCopy"></i>
                  </button>

                  <span className="mx-3">
                    <span className="text-light">Total Videos</span>
                    <h5>
                      <big className="text-warning">{Number(videoNumber)}</big>
                    </h5>
                  </span>
                </div>
              </div>
              <div className="cFour m-3  p-2 rounded-3">
                <div className="d-flex">
                  <button>
                    <img src={sign} className="img-fluid iconJury" alt="" />
                  </button>
                  <span className="mx-3">
                    <span className="text-light">Marked Videos</span>
                    <h5>
                      <big className="text-warning">
                        {Number(markedVideoNumber)}
                      </big>
                    </h5>
                  </span>
                </div>
              </div>
              <div className="ffdNine m-3  p-2 rounded-3">
                <div className="d-flex">
                  <button>
                    <img src={decline} className="img-fluid iconJury" alt="" />
                  </button>
                  <span className="mx-3">
                    <span className="text-light">Non Marked Videos</span>
                    <h5>
                      <big className="text-warning">
                        {Number(nonMarkedVideoNumber)}
                      </big>
                    </h5>
                  </span>
                </div>
              </div>
              <div className="m-3">
                <button
                  onClick={handleDetails}
                  className="w-100 btn grayBg p-2"
                >
                  <big className="text-dark fw-bold">Details</big>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default JuryGroupCard;
